import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountInternationalIPReady = (account: IAccount) =>
  account.country === "CA" &&
  account.currency === "CAD" &&
  account.status !== AccountStatus.Inactive;
